<template>
  <div>
    <div id="taekwondo">
      <div class="col-50">
        <div class="block">
          <card
            :titleLabel="$t('label.taekwondoView.logos.1.title')"
            :subtitleLabel="$t('label.taekwondoView.logos.1.subtitle')"
            :imageLogo="urlsAndLogos[1].img"
            :numberPhotos="numberPhotos[1]"
            :labelImageToShow="labelPhotos[1]"
          ></card>
        </div>
      </div>
      <div class="col-50">
        <div class="block">
          <card
            :titleLabel="$t('label.taekwondoView.logos.2.title')"
            :subtitleLabel="$t('label.taekwondoView.logos.2.subtitle')"
            :imageLogo="urlsAndLogos[2].img"
            :numberPhotos="numberPhotos[2]"
            :labelImageToShow="labelPhotos[2]"
          ></card>
        </div>
      </div>

      <div class="clear"></div>
    </div>
    <div>
      <div class="col-50">
        <div class="block">
          <card
            :titleLabel="$t('label.taekwondoView.logos.3.title')"
            :subtitleLabel="$t('label.taekwondoView.logos.3.subtitle')"
            :imageLogo="urlsAndLogos[3].img"
            :numberPhotos="numberPhotos[3]"
            :labelImageToShow="labelPhotos[3]"
          ></card>
        </div>
      </div>
      <div class="col-50">
        <div class="block">
          <card
            :titleLabel="$t('label.taekwondoView.logos.4.title')"
            :subtitleLabel="$t('label.taekwondoView.logos.4.subtitle')"
            :imageLogo="urlsAndLogos[4].img"
            :numberPhotos="numberPhotos[4]"
            :labelImageToShow="labelPhotos[4]"
          ></card>
        </div>
      </div>

      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from "./constants.js";
import Card from "@/components/card/Card.vue";

export default {
  name: "Taekwondo",

  components: {
    Card
  },

  computed: {
    urlsAndLogos() {
      return CONSTANTS.URLS_DOCS;
    },
    numberPhotos() {
      return CONSTANTS.NUMBER_PHOTOS;
    },
    labelPhotos() {
      return CONSTANTS.LABEL_PHOTOS;
    }
  }
};
</script>

<style>
#taekwondo {
  margin-top: 350px;
}

@media (max-width: 780px) {
  #taekwondo {
    margin-top: 310px;
  }
}

@media (max-width: 330px) {
  #taekwondo {
    margin-top: 350px;
  }
}
</style>
